import React, { Component } from 'react';
import {
    Container,
    Card,
    CardHeader, CardBody,
    Input,
    Button,
    Row,
    Col,
    Collapse
} from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons'
import CompanyContext from '../../auth/CompanyContext';

class ImportSalesOpportunities extends Component {
    static contextType = CompanyContext;

    constructor(props) {

        super(props);

        this.batchLimit = 100;

        this.state = {
            data: [],
            results: null,
            isDone: false,
            inputFile: '',
            error: '',
            open: (this.props.open !== undefined) ? this.props.open : false,
            statuses: [],
            stages: [],
            types: [],
            users: [],
            incompleteCompanies: false,
            maxCompanyNumber: 0,
        };

    }

    componentDidMount() {
        this.getStatuses();
        this.getUsers();
    }

    componentWillUnmount() {
        this.setState = (state, callback) => {
            return;
        };
    }

    getStatuses = () => {
        fetch('/api/opportunities/', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken,
                'X-Database': this.context.company
            }
        })
            .then(results => results.json())
            .then(results => {
                this.setState({
                    stages: results.data.filter(item => item.Type === 'stage').map(item => {
                        const retArray = item.Opportunity.split('-').map(part => part.trim());
                        return { id: item.ID, name: retArray.length > 1 ? retArray[1] : retArray[0], value: !isNaN(parseInt(retArray[0])) ? parseInt(retArray[0]) : null }
                    }),
                    statuses: results.data.filter(item => item.Type === 'status')
                        .map(item => {
                            const retArray = item.Opportunity.split('-').map(part => part.trim());
                            return { id: item.ID, name: retArray.length > 1 ? retArray[1] : retArray[0], value: !isNaN(parseInt(retArray[0])) ? parseInt(retArray[0]) : null }
                        }
                        ),
                    types: results.data.filter(item => item.Type === 'type').map(item => {
                        return { id: item.ID, name: item.Opportunity }
                    }),
                });
            });
        return;
    }

    getUsers = () => {
        fetch('/api/users/', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken,
                'X-Database': this.context.company
            }
        })
            .then(results => results.json())
            .then(results => {
                this.setState({
                    users: results.data
                });
            });
    }

    normalizeStage = (input) => {
        if (!input) return '';
        const category = this.state.stages.find(item => item.name.toLowerCase().trim() === input.toLowerCase().trim()
            || (!isNaN(parseInt(input)) && item.value.toLowerCase() === parseInt(input)))
        if (!category) return '';
        return String(category.id);
    }

    normalizeStatus = (input) => {
        if (!input) return '';
        const category = this.state.statuses.find(item => item.name.toLowerCase().trim() === input.toLowerCase().trim()
            || (!isNaN(parseInt(input)) && item.value.toLowerCase() === parseInt(input)))
        if (!category) return '';
        return String(category.id);
    }

    normalizeType = (input) => {
        if (!input) return '';
        const category = this.state.types.find(item => item.name.toLowerCase().trim() === input.toLowerCase().trim())
        if (!category) return '';
        return String(category.id);
    }

    normalizeDate = (input) => {
        if (!input) return '';

        // Case 1: Already in yyyy-mm-dd from <input type="date">
        const isoPattern = /^\d{4}-\d{2}-\d{2}$/;
        if (isoPattern.test(input)) return input;

        // Try to parse any common format
        const parsed = new Date(input);
        if (isNaN(parsed)) return '';

        // Format to yyyy-mm-dd
        const y = parsed.getFullYear();
        const m = String(parsed.getMonth() + 1).padStart(2, "0");
        const d = String(parsed.getDate()).padStart(2, "0");
        return `${y}-${m}-${d}`;
    }

    normalizeAmount = (input) => {
        if (input === null || input === undefined) return input;

        // Strip $ and commas
        let raw = String(input).trim().replace(/^\$/, "").replace(/,/g, "");
        if (raw === "" || isNaN(raw)) return input;

        let hasDecimals = raw.includes(".");
        let intPart, decPart;

        if (hasDecimals) {
            [intPart, decPart] = raw.split(".");

            // Clamp to cents (0–99) — ignore anything past 2 digits
            decPart = decPart.slice(0, 2);

            // If the decimal is empty after slicing, treat as no decimals
            if (decPart.length === 0) {
                hasDecimals = false;
            }
        }

        const intFormatted = Number(hasDecimals ? intPart : raw)
            .toLocaleString("en-US", { maximumFractionDigits: 0 });

        if (hasDecimals) {
            return `${intFormatted}.${decPart}`;
        }

        return `${intFormatted}`;
    }

    normalizeBoolean = (input, defaultVal) => {
        if (!input) return defaultVal;
        const inputLowerTrim = String(input).toLowerCase().trim();
        return (inputLowerTrim === 'no' || inputLowerTrim === 'false' || inputLowerTrim === '0' || inputLowerTrim === 'inactive') ? false : true;
    }

    normalizeUser = (input, returnOriginal) => {
        if (!input || !input.trim()) return '';

        const norm = s => s.toLowerCase().replace(/\s+/g, ' ').trim();
        const clean = norm(input);

        for (const user of this.state.users) {
            const uFirst = norm(user["First Name"] || "");
            const uLast = norm(user["Last Name"] || "");

            // Build candidate match strings
            const form1 = `${uFirst} ${uLast}`;     // "first last"
            const form2 = `${uLast} ${uFirst}`;     // "last first"
            const form3 = `${uLast}, ${uFirst}`;    // "last, first"

            if (clean === form1 || clean === form2 || clean === form3) {
                return returnOriginal ? '' : (user?.Auth0 || '');
            }
        }

        return returnOriginal ? input : '';
    };

    parseCSVLine = (line) => {
        const result = [];
        let currentField = "";
        let insideQuotes = false;

        for (let char of line) {
            if (char === '"' && insideQuotes) {
                insideQuotes = false; // Closing a quoted field
            } else if (char === '"' && !insideQuotes) {
                insideQuotes = true; // Opening a quoted field
            } else if (char === "," && !insideQuotes) {
                result.push(currentField); // End of field
                currentField = "";
            } else {
                currentField += char; // Append character to the current field
            }
        }

        result.push(currentField); // Add the last field
        return result.map((field) => (field.startsWith('"') && field.endsWith('"') ? field.slice(1, -1) : field)); // Remove surrounding quotes
    };

    handleUpload = (e) => {
        e.preventDefault();
        const file = e.target.files[0];
        this.setState({
            inputFile: file
        }, () => {
            const reader = new FileReader();

            reader.onload = (e) => {
                const text = e.target.result;

                const rows = text.split("\n").map((line) => {
                    return this.parseCSVLine(line); // Custom function to handle quoted fields
                });

                const [headers, ...dataRows] = rows;
                const data = dataRows.map((row) => {
                    return headers.reduce((acc, header, index) => {
                        acc[header.trim()] = row[index]?.trim();
                        return acc;
                    }, {});
                });

                let dataArray = [];
                data.forEach(item => {
                    if (!item['Opportunity Name']) {
                        return;
                    }
                    let opportunityIndex = (dataArray.findIndex(opportunityArr => opportunityArr.opportunityName === item['Opportunity Name'] && opportunityArr.companyNumber === item['Company Number']));
                    if (opportunityIndex === -1) {
                        dataArray.push({
                            waNumber: item['WA#'] || item['WA Number'] || '',
                            opportunityName: item['Opportunity Name'],
                            companyName: item['Company Name'],
                            companyNumber: item['Company Number'],
                            date: this.normalizeDate(item['Date']),
                            opportunityTypeID: this.normalizeType(item['Type']),
                            opportunityStatusID: this.normalizeStatus(item['Status']),
                            opportunityStageID: this.normalizeStage(item['Stage']),
                            opportunityAssigneeUserID: this.normalizeUser(item['Assignee'], false),
                            opportunityAssigneeUserOther: this.normalizeUser(item['Assignee'], true),
                            opportunitySalesRepUserID: this.normalizeUser(item['Sales Rep'], false),
                            opportunitySalesRepUserOther: this.normalizeUser(item['Sales Rep'], true),
                            opportunityAmount: this.normalizeAmount(item['Opportunity Amount']),
                            active: this.normalizeBoolean(item['Active'], true),
                            maintenanceRequirementStatus: item['Maintenance Requirement Status'],
                            maintenanceAcceptanceStatus: item['Maintenance Acceptance Status'],
                            maintenanceEndDate: this.normalizeDate(item['Maintenance End Date']),
                            maintenanceNotes: item['Maintenance Notes'],
                            nextSteps: item['Next Steps'],
                            randomKey: Math.round(Math.random() * 100000000)
                        })
                        
                    }
                })

                this.setState({
                    data: dataArray,
                    incompleteCompanies: []
                }, () => {
                    this.insertData(dataArray);
                })
            };
            reader.readAsText(file);
        })
    }

    insertData(dataArray, incompleteCompanies) {
        fetch('/api/import/salesOpportunities/', {
            method: 'POST',
            body: JSON.stringify({
                data: dataArray,
                incompleteCompanies
            }),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken,
                'X-Database': this.context.company
            }
        })
            .then(async response => ({ ok: response.ok, results: await response.json() }))
            .then(({ ok, results }) => {
                if (!ok || results?.debug_message?.error != null || results?.error) {
                    throw new Error(results.message || results.error || 'Unable to fully process uploaded file');
                }
                this.setState({
                    isDone: true,
                    maxCompanyNumber: results.maxCompanyNumber,
                    data: results.data,
                    incompleteCompanies: results.incompleteCompanies,
                    results: results.results
                })
            })
            .catch(reason => {
                this.setState({
                    isDone: true,
                    results: null,
                    error: reason.message || 'Unable to process uploaded file'
                })
            })

    }

    resetUpload = () => {
        this.setState({
            data: [],
            isDone: false,
            inputFile: '',
            results: null,
            error: ''
        })
    }

    finishUpload = () => {
        this.insertData(this.state.data, this.state.incompleteCompanies.filter(item => item.companyNumber !== '' && item.companyName !== ''))
    }

    changeIncompleteCompany = (value, randomKey, prop) => {
        this.setState((prev) => {
            const incompleteCompanies = prev.incompleteCompanies;
            const data = prev.data;
            const targetIC = incompleteCompanies.findIndex(item => item.randomKey === randomKey);
            const targetData = data.findIndex(item => item.randomKey === randomKey);
            incompleteCompanies[targetIC][prop] = value;
            data[targetData][prop] = value;
            return {
                data,
                maxCompanyNumber: prev.maxCompanyNumber,
                incompleteCompanies: incompleteCompanies
            }
        })
    }

    autoGenerate = (index, offset = 0) => {
        const max = (Number(this.state.maxCompanyNumber)) + offset + 10;
        if (this.state.data.findIndex(item => item.companyNumber === `999-${max}`) > -1) return this.autoGenerate(index, offset + 10);
        this.setState((prev) => {
            const incompleteCompanies = prev.incompleteCompanies;
            incompleteCompanies[index].companyNumber = '999-' + max;
            const data = prev.data;
            const targetData = data.findIndex(item => item.randomKey === incompleteCompanies[index].randomKey);
            data[targetData].companyNumber = '999-' + max;
            return {
                data,
                maxCompanyNumber: max,
                incompleteCompanies: incompleteCompanies
            }
        })
    }

    showHide(element) {
        this.setState({
            open: !this.state.open
        })
    }

    render() {
        let duplicates = false;
        if (this.state?.incompleteCompanies) {
            duplicates = [...this.state.incompleteCompanies].filter(item => item.companyNumber !== '')
                .map(i => i.companyNumber)
                .filter((v, i, a) => a.indexOf(v) !== i);
        }
        return (
            <Container fluid>
                <Card>
                    <CardHeader onClick={() => this.showHide()}>
                        <Row className="align-items-center">
                            <Col className="col-md-11 text-left">
                                <h3>Import Sales & Opportunities</h3>
                            </Col>
                            <Col xs="1" className="text-right">
                                {(this.state.open) ? <FontAwesomeIcon icon={faChevronUp} /> : <FontAwesomeIcon icon={faChevronDown} />}
                            </Col>
                        </Row>
                    </CardHeader>
                    <Collapse isOpen={this.state.open}>
                        <CardBody>
                            {(!this.state.isDone) ?
                                <>
                                    <Row className="align-items-center">
                                        <Col className="col-md-6 text-left">
                                            <Input type="file" name="file" accept='.csv' onChange={e => this.handleUpload(e)} value="" />
                                        </Col>
                                        <Col className="col-md-6 text-right">
                                            Imports a sales & opportunities .csv
                                            <p><a href='/crm-opportunities-template.csv' download>Download CSV Template</a></p>
                                        </Col>
                                    </Row>
                                </> : <></>
                            }
                            {this.state.error &&
                                <Row>
                                    <Col className="text-left text-danger">
                                        {this.state.error}
                                    </Col>
                                    <Col className="text-right">
                                        <Button color="primary" onClick={this.resetUpload}>Import Another</Button>
                                    </Col>
                                </Row>
                            }
                            {this.state.results && this.state.incompleteCompanies &&
                                <Row>
                                    <Col className="text-left">
                                        <p>To complete the import, please identify any missing company information (entries without both fields will not be added):</p>
                                        <Row className='font-weight-bold'>
                                            <Col xs={6}>
                                                Company Name
                                            </Col>
                                            <Col>
                                                Company Number
                                            </Col>
                                        </Row>
                                        {this.state.incompleteCompanies.map((company, companyIndex) => (
                                            <Row className='mt-2' key={companyIndex}>
                                                <Col xs={6}>
                                                    <Input
                                                        className={duplicates.findIndex(item => item === company.companyNumber) > -1 ? "border border-danger" : (this.state.incompleteCompanies[companyIndex].companyName !== '' && this.state.incompleteCompanies[companyIndex].companyNumber !== '' ? 'border border-success' : '')}
                                                        onChange={(e) => this.changeIncompleteCompany(e.target.value, company.randomKey, 'companyName')}
                                                        value={company.companyName}
                                                    />
                                                </Col>
                                                <Col className='pr-1'>
                                                    <Input
                                                        className={duplicates.findIndex(item => item === company.companyNumber) > -1 ? "border border-danger" : (this.state.incompleteCompanies[companyIndex].companyName !== '' && this.state.incompleteCompanies[companyIndex].companyNumber !== '' ? 'border border-success' : '')}
                                                        onChange={(e) => this.changeIncompleteCompany(e.target.value, company.randomKey, 'companyNumber')}
                                                        value={company.companyNumber}
                                                    />
                                                </Col>
                                                <Col xs={2} className='pl-1'>
                                                    {company.companyNumber === '' &&
                                                        <Button color="secondary" onClick={() => this.autoGenerate(companyIndex)}>Auto Generate</Button>}
                                                </Col>
                                            </Row>
                                        ))}
                                    </Col>
                                    <Col className="text-right" xs={2}>
                                        <Button disabled={duplicates.length > 0} color="primary" onClick={this.finishUpload}>Finish Import</Button>
                                    </Col>
                                </Row>
                            }
                            {this.state.results && !this.state.incompleteCompanies &&
                                <Row>
                                    <Col className="text-left">
                                        <p>New sales & opportunities added to database: <strong>{(this.state.results?.unmatchedOpportunities?.length || 0) + (this.state.results?.missingCompanyNumberContacts?.length || 0)}</strong></p>
                                        <p>Existing sales & opportunities in database: <strong>{this.state.results?.matchedOpportunities?.length || 0}</strong></p>
                                        <p>Sales & opportunities not associated with a company: <strong>{this.state.results?.missingCompanyNumberOpportunities?.length || 0}</strong></p>
                                        <p>Companies not in database: <strong>{this.state.results?.missingCompanyNumbers?.length || 0}</strong></p>
                                    </Col>
                                    <Col className="text-right">
                                        <Button color="primary" onClick={this.resetUpload}>Import Another</Button>
                                    </Col>
                                </Row>
                            }
                        </CardBody>
                    </Collapse>
                </Card>
            </Container>
        );
    }
}

export default ImportSalesOpportunities;
